

jQuery(document).ready(function($) {
	
	launchHomeCarousels($);
	carouselWorks($, '.carousel-works');
	carouselClients($, '.carousel-clients');
	carouselDefault($, '.carousel-skill');

});

function carouselLogos($, sliderSelector) {

	var swiper = new Swiper(sliderSelector, {
		slidesPerView: 5,
		spaceBetween: 30,
		autoplay: {
			delay: 5000,
		},
		breakpoints: {
			0: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			1200: {
				slidesPerView: 6,
			},
			1441: {
				slidesPerView: 6,
			},
			1921: {
				slidesPerView: 6,
			}
		}
    });
}

function launchHomeCarousels($) {
	let delay = 0;
	for ( var i = 1; i <= 3; i++ ) {
		delay = delay + 1200;
		setTimeout(carouselDefault, delay, $,'.carousel-header-'+i);
	}
}

function carouselDefault($, sliderSelector) {

	var swiper = new Swiper(sliderSelector, {
		slidesPerView: 1,
		effect: 'fade',
		speed: 2000,
		allowTouchMove: false,
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 4000,
		},
	});

}

function carouselClients($, sliderSelector) {
    
	var swiper = new Swiper(sliderSelector, {        
		
		slidesPerColumnFill: 'row',        
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
		autoplay: {
			delay: 3000,
		},
		breakpoints: {
			0: {
				slidesPerView: 2, 
				slidesPerColumn: 1, 
				slidesPerGroup: 1
			},
			768: {
				slidesPerView: 3, 
				slidesPerColumn: 1, 
				slidesPerGroup: 1
			},
			1200: {
				slidesPerView: 3, 
				slidesPerColumn: 1, 
				slidesPerGroup: 1
			},
			1441: {
				slidesPerView: 4, 
				slidesPerColumn: 2, 
				slidesPerGroup: 1
			},
			1921: {
				slidesPerView: 5, 
				slidesPerColumn: 2, 
				slidesPerGroup: 1
			}
		}
    });

}


function carouselWorks($, sliderSelector) {
    
	var swiper = new Swiper(sliderSelector, {
        slidesPerView: "auto",
		speed: 800,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        }, 
		autoplay: false,
		navigation: {
			nextEl: '.swiper-button-next.next-works',
			prevEl: '.swiper-button-prev.prev-works'
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
			}
		}
    });

} 